<div class="code-wrapper">
  <input type="password"
         maxlength="1"
         *ngFor="let key of keys; let i = index;"
         [style.width.%]="width"
         [placeholder]="placeholder(i)"
         [formControl]="control(key)"
         (paste)="onPaste($event, i)"
         (keyup)="onInput($event)"
  >
</div>
